
import {isAPP} from "@/appApi";
import store from '../../store';

export function isLogin(referer: string) {
    if (isAPP()) {
        // todo 以后获取token
        return true;
    }
    const isLogin = store.state.isLogin;
    if (isLogin) {
        return true;
    }
    setLogin(referer);
    return false;
}

export function setLogin(referer: string) {
    let host:any = referer.split('?');
    host = host[0];
    const params = getRequestParams(referer);
    let n = 0;
    for(const i in params) {
        if (i !== 'sessionid') {
            host = `${host}${n===0?'?':'&'}${i}=${params[i]}`
        }
        n++;
    }
    const url = encodeURIComponent(host);
    location.href = `/login?from_url=${url}`
}

export function getRequestParams(urlStr: string) {
    const url = "?" + urlStr.split("?")[1];
    const theRequest: any = new Object();
    if (urlStr.indexOf("?") !== -1) {
        const str: any = url.substr(1);
        const strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}